import React, { useContext, useState } from 'react';
import { Grid, NumberInput, Button, Divider, Select, MultiSelect, FileInput, Pill, Loader, TextInput } from "@mantine/core";
import { IconAlertHexagonFilled, IconExternalLink, IconPhoto } from '@tabler/icons-react';
import AuthContext from '../../../../../contexts/AuthContext';
import moment from 'moment';
import axios from 'axios';
import { DateInput } from '@mantine/dates';
import { showNotification } from '@mantine/notifications';
import AcademicContext from '../../../../../contexts/AcademicContext';
import AppContext from '../../../../../contexts/AppContext';
import { renderFile } from '../../../../../utils/renderFile';
import useS3 from '../../../../../hooks/useS3';
import { isBase64 } from '../../../../../utils/isBase64';
import { openBase64InNewTab } from '../../../../../utils/openBase64InNewTab';
import { openUrl } from '../../../../../utils/openUrl';
import { isoToLocalDateInput, toUTCMidnight } from '../../../../../utils/courses-dates';
import MantineSwitchButton from '../../../../../components/MantineSwitchButton/MantineSwitchButton';


const createAcademicUnit = async (values, config) => {
    let jsonData = {
        data: {
            ...values,
            name: values.name.toUpperCase(),
            description: values.description.toUpperCase(),

            initialDate: toUTCMidnight(values.initialDate),
            endDate: toUTCMidnight(values.endDate),
            closeCampusDate: toUTCMidnight(values.closeCampusDate),
            classDays: values.classDays.toUpperCase(),
            exams: values.examId ?? null,
            is_wp_group: values?.is_wp_group || false,
        },
    };

    return axios.post(
        `${process.env.REACT_APP_BACKEND_SERVER}admin/academico/createAcademicUnit`,
        jsonData,
        config
    );
};

const getMonthByType = (type) => {
    if (!type) return 3
    const value = type.toLowerCase()
    if (value === 'masterclass') return 1
    if (value === 'taller') return 1
    if (value === 'bootcamp') return 2
    if (value === 'curso') return 3
    if (value === 'webinar') return 3
    if (value === 'posgrado') return 6
    if (value === 'diplomado') return 12
}

function NewAcademicUnitByModule(props) {
    const { formHandler, allData, onCreateAcademicUnitByModule } = props;
    const { authToken } = useContext(AuthContext)
    const { specialtiesOptions } = useContext(AcademicContext)
    const { staffUsers } = useContext(AppContext)
    const { uploadToS3 } = useS3();

    const [isLoading, setIsLoading] = useState(false)
    const [isImageUploading, setIsImageUploading] = useState(false)

    const handleUploadToS3 = async (_file, _name) => {
        return uploadToS3({
            image: _file,
            fileDirectory: `public/images/academicUnits`,
            fileName: `${_name}`,
            isRequired: false
        })
    }

    const handleSubmit = async () => {

        const axiosConfig = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
        };

        const module_data = allData.moduleData


        const form_handler_values = formHandler.values

        const endDateRaw = form_handler_values.endDate;
        const endDateByType = getMonthByType(form_handler_values.type) || 2
        const calculatedCloseDate = toUTCMidnight(
            moment(endDateRaw).add(endDateByType, 'months').toDate()
        );



        const new_values = {
            initialDate: form_handler_values.initialDate,
            endDate: endDateRaw,
            closeCampusDate: calculatedCloseDate,
            price: {
                usd: form_handler_values.price.usd,
                ars: form_handler_values.price.ars
            },
            image: form_handler_values.image,
            is_elite: false,
            initBreak: null,
            endBreak: null,
            director: [],
            codirector: [],
            exam: null,
            subscriptionPlans: []
        }

        formHandler.setValues(prev => ({ ...prev, ...new_values }))

        try {
            setIsLoading(true)

            await createAcademicUnit({
                ...formHandler.values,
                ...new_values, modules: [module_data.value],
                is_created_by_module: true
            },
                axiosConfig)

            formHandler.reset()
            onCreateAcademicUnitByModule()
            showNotification({
                color: "green",
                status: "success",
                title: "¡Excelente! Operación exitosa.",
                message: 'La unidad académica ha sido creada correctamente.',
                autoClose: 12000
            });
        } catch (error) {
            console.log(error)
            showNotification({
                color: "red",
                status: "error",
                title: "Operación fallida.",
                message: `No se pudo crear la unidad académica. Detalle: ${error}`,
                autoClose: 12000
            });
        } finally {
            setIsLoading(false)
        }
    }

    return <div className="NewAcademicUnitByModal__container">
        <div className="moderationContainer-warning-container">
            <IconAlertHexagonFilled className="moderationContainer-alertIcon" />
            <p className="moderationContainer-modalText">
                Estás por crear una nueva unidad académica a partir del módulo, asegurate de estar seguro del
                siguiente cambio.
            </p>
        </div>



        <Grid mt={12} style={{ width: "100%" }}>
            <Grid.Col span={12}>
                <TextInput
                    label='Nombre de la unidad académica'
                    {...formHandler.getInputProps('name')}
                />
            </Grid.Col>
            <Grid.Col span={12}>
                <Select
                    required
                    allowDeselect={false}
                    data={[
                        { value: "Curso", label: "Curso" },
                        { value: "Masterclass", label: "Masterclass" },
                        { value: "Diplomado", label: "Diplomado" },
                        { value: "Posgrado", label: "Posgrado" },
                        { value: "Webinar", label: "Webinar" },
                        { value: "Taller", label: "Taller" },
                        { value: "Bootcamp", label: "Bootcamp" },
                    ]}
                    label='Tipo de curso'
                    {...formHandler.getInputProps('type')}

                />
            </Grid.Col>
            <Grid.Col span={12}>
                <MultiSelect
                    {...formHandler.getInputProps("specialties")}
                    label="Especialidades"
                    data={specialtiesOptions}
                    required
                    searchable
                />
            </Grid.Col>
            {<Grid.Col span={12}>
                <Select
                    label="División"
                    required
                    allowDeselect={false}
                    {...formHandler.getInputProps('division')}
                    data={[{
                        label: "Grandes animales",
                        value: "LARGE"
                    },
                    {
                        label: "Pequeños animales",
                        value: "SMALL"
                    }]}
                    searchable
                />
            </Grid.Col>}
            <Grid.Col span={12}>
                <Select
                    label="Coordinadores"
                    {...formHandler.getInputProps('coordinator')}
                    data={staffUsers}
                    searchable
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <NumberInput
                    label="Precio USD"
                    required
                    min={1}
                    {...formHandler.getInputProps('price.usd')}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <NumberInput
                    label="Precio ARS"
                    min={1}
                    required
                    {...formHandler.getInputProps('price.ars')}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <DateInput
                    label="Fecha de inicio"
                    placeholder="Selecciona una fecha"
                    locale="es"
                    required
                    valueFormat="DD [de] MMMM YYYY"
                    defaultValue={
                        formHandler.values.comercialInformation?.initialDateISO
                            ? isoToLocalDateInput(formHandler.values.comercialInformation.initialDateISO)
                            : null
                    }
                    onChange={(newDate) => {
                        if (!newDate) {
                            formHandler.setFieldValue('initialDate', "");
                            return;
                        }
                        formHandler.setFieldValue('initialDate', newDate);
                    }}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <DateInput
                    label="Fecha de finalización"
                    placeholder="Selecciona una fecha"
                    locale="es"
                    required
                    valueFormat="DD [de] MMMM YYYY"
                    defaultValue={
                        formHandler.values.comercialInformation?.endDateISO
                            ? isoToLocalDateInput(formHandler.values.comercialInformation.endDateISO)
                            : null
                    }
                    onChange={(newDate) => {
                        if (!newDate) {
                            formHandler.setFieldValue('endDate', "");
                            return;
                        }
                        formHandler.setFieldValue('endDate', newDate);
                    }}
                />
            </Grid.Col>

            <Grid.Col span={6}>
                <FileInput
                    {...formHandler.getInputProps("image")}
                    label="Cargar imagen de la unidad académica"
                    withAsterisk
                    w={"100%"}
                    description="La nueva imagen reemplazará al anterior."
                    placeholder="Cargar imagen"
                    leftSection={<IconPhoto size={30} />}
                    disabled={(formHandler.values.name === "") || isImageUploading}
                    onChange={(file) => {
                        renderFile(file)
                            .then(async (_fileBase64) => {
                                setIsImageUploading(true);
                                const fileName = formHandler.values.name
                                    ? formHandler.values.name.toLowerCase().replace(/ /g, '_')
                                    : file.name.toLowerCase().replace(/ /g, '_');

                                await handleUploadToS3(_fileBase64, fileName).then((url) => {
                                    formHandler.setFieldValue("image", url);
                                }).catch((error) => {
                                    showNotification({
                                        color: 'red',
                                        status: 'error',
                                        title: 'Ha ocurrido un problema al cargar el archivo.',
                                        autoClose: 12000,
                                        message: `Detalle: ${error}`
                                    });
                                }).finally(() => {
                                    setIsImageUploading(false)
                                });
                            });
                    }}
                    accept={['image/*']}
                />
            </Grid.Col>
            {formHandler.values.image && (
                <Grid.Col span={6}>
                    <div className="SalesPaymentForm-iamgeLink-div">
                        <h6 className="SalesPaymentForm-image-header">
                            Link de la imagen
                        </h6>
                        {isImageUploading ? <Loader /> : <div className="SalesPaymentForm-pill-container">
                            <Pill>
                                {formHandler.values.image}
                            </Pill>
                            <IconExternalLink className='materialsTable__icon' onClick={() => {
                                if (!formHandler.values.image || formHandler.values.image === "Sin imagen") {
                                    showNotification({
                                        color: "yellow",
                                        status: "warning",
                                        title: "La imagen no existe",
                                        message: `Detalle: No se ha cargado una imagen.`,
                                        autoClose: 12000
                                    });
                                } else if (isBase64(formHandler.values.image)) {
                                    openBase64InNewTab(formHandler.values.image);
                                } else {
                                    openUrl(formHandler.values.image)
                                }
                            }} />
                        </div>}
                    </div>
                </Grid.Col>
            )}
            <Grid.Col span={12}>
                <MantineSwitchButton
                    checked={formHandler.values.is_wp_group}
                    onChange={() =>
                        formHandler.setFieldValue("is_wp_group", !formHandler.values.is_wp_group)
                    }
                    label={<span>¿Crear <strong>grupo de WhatsApp</strong>?</span>}
                />
            </Grid.Col>


        </Grid>

        <Button loading={isLoading} disabled={isLoading} type='button' onClick={handleSubmit} className="subscriptionPlanModal__button">
            Crear unidad academica
        </Button>
    </div>


}

export default NewAcademicUnitByModule;